import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from 'src/app/shared/models/TranslationRequest';

@Component({
  selector: 'app-about-dialog',
  template: `
    <app-dialog
      [title]="'About us' | translation : translationRequest| sentenceCase "
      ariaLabel="'About us dialog' | translation : translationRequest | sentenceCase"
      [showHeader]="true"
      [showCancel]="false"
      [showConfirm]="true"
      [confirmLabel]="'Ok' | translation : translationRequest | sentenceCase "
      [showActions]="true"
      [btnConfirmAltText]="'Ok' | translation : translationRequest | sentenceCase "
      [btnConfirmTitleText]="'Ok' | translation : translationRequest | sentenceCase "
      [width]="500"
      (confirmEvent)="onClose($event)"
    >
      <div class="tw-p-4">
        <p class="tw-text-[14px] tw-text-gray-700 tw-leading-relaxed">
          {{'To access mySedgwick, you will need a recent version of Google Chrome,Microsoft Edge, Mozilla Firefox, or Safari. JavaScript must be enabled in the browser for the site to function correctly. To enable your browser for JavaScript, please consult your browser documentation.'  | translation : translationRequest | sentenceCase }}
          <br aria-hidden="true" />
          <br aria-hidden="true" />
          {{'All rights reserved. No part of this information may be reproduced in any form by any electronic or mechanical means including 
          information storage and retrieval systems without the written permission of Sedgwick Claims Management Services, Inc.' | translation : translationRequest | sentenceCase }}
        </p>
      </div>
    </app-dialog>
  `,
})
export class AboutDialogComponent implements OnInit {
  translationRequest: TranslationRequest = new TranslationRequest(
    {
      language: sessionStorage.getItem('languagepreference'), // Default to English, you can make this dynamic
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'Shared',
      subGroup: 'Shared',
      saveToCache: false
    }
  );

  constructor(private dialogRef: MatDialogRef<AboutDialogComponent>,  
    public translationService: TranslationService) {
  }

  ngOnInit(): void {
    // No translation loading needed since text is hardcoded since we are storing it as shared with first run
  }
  
  onClose(result: string): void {
    this.dialogRef.close(result);
  }
}
